


















































import { Component, Vue } from 'vue-property-decorator'
import { PrintableDocument } from '@/api/model/printable-document'
import { PrintableDocumentAPI } from '@/api/backend-client'
import { v4 as uuid } from 'uuid'

@Component
export default class CompanySettingsEmmaDirectMailPrintableDocumentsCreate extends Vue {
    printableDocument: PrintableDocument = null
    printableDocumentFile: File = null
    saving: boolean = false

    async created(): Promise<void> {
        this.printableDocument = PrintableDocument.fromData({
            company: this.$currentCompany,
            id: uuid(),
            name: '',
            description: '',
            productId: null,
            active: true,
            createdAt: new Date(),
            updatedAt: new Date(),
        })
    }

    async save(): Promise<void> {
        this.saving = true
        this.printableDocument = await PrintableDocumentAPI.createWithFile(this.printableDocument, this.printableDocumentFile)
        this.saving = false
        await this.goToList()
    }

    async cancel(): Promise<void> {
        await this.goToList()
    }

    async goToList(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_emma_direct_mail_printable_documents_list',
        })
    }

    get productIdOptions() {
        const productIds = [
            'kaart_dubbel_10x10',
            'kaart_dubbel_14x14',
            'kaart_dubbel_a5_sta',
            'kaart_dubbel_a6_sta',
            'kaart_enkel_a5_lig',
            'kaart_enkel_a6_lig',
            'kaart_enkel_a6_sta',
            'boek_ge_a4_sta',
            'boek_ge_a5_sta',
            'magazine_21x21',
            'magazine_a4_lig',
            'magazine_a4_sta',
            'magazine_a5_lig',
            'magazine_a5_sta',
        ]

        return productIds.map((productId: string) => {
            return {
                label: this.$t('company_settings.emma_direct_mail.printable_documents.field.productIds.' + productId),
                value: productId,
            }
        })
    }

    get yesNoOptions() {
        return [
            { label: this.$t('yes'), value: true },
            { label: this.$t('no'), value: false },
        ]
    }
}
